import { FC, useEffect, useState } from "react";
import styles from "./sumaryOrder.module.css";
import { BsCart2, BsChevronDown, BsChevronUp } from "react-icons/bs";
import { floatToPriceWithoutSpace } from "../../functions/price_functions";

import { useOrder } from "../../hooks/useOrder";
import { useDiscount } from "../../hooks/useDiscount";

type PropsSumaryOrder = {
  totalWithoutDiscountProps?: number;
  totalProps?: number;
  freightProps?: number;

  page: "pagamento" | "finalizado" | "informacao" | "sucesso";
};

const SumaryOrder: FC<PropsSumaryOrder> = ({
  totalWithoutDiscountProps,
  page,
}) => {
  const { freight, totalValue, totalValueWithoutDiscount, type } = useOrder();
  const [isOpen, setIsOpen] = useState(false);
  const discountContext = useDiscount();

  let todosDescontos = 0;

  let totalPedido = 0;
  switch (page) {
    case "pagamento":
      totalPedido = totalValue + freight;
      todosDescontos =
        discountContext.data.couponValue +
        discountContext.data.paymentDiscountValue;
      break;
    case "finalizado":
      totalPedido = totalValue + freight;
      todosDescontos =
        discountContext.data.couponValue +
        discountContext.data.paymentDiscountValue;
      break;
    case "informacao":
      totalPedido = totalValue + freight;
      todosDescontos = discountContext.data.couponValue;
      break;
    case "sucesso":
      totalPedido = totalValue;
      todosDescontos =
        discountContext.data.couponValue +
        discountContext.data.paymentDiscountValue;
      break;
    default:
      totalPedido = totalValue;
      todosDescontos = discountContext.data.couponValue;
      break;
  }

  const totalSemDesconto = totalValueWithoutDiscount;

  return (
    <div className={styles.sumary_order}>
      <div className={styles.sumary_order_card}>
        <div className={styles.sumary_order_card_header}>
          {
            /* Novo Icone do carrinho */
            <>
              <svg
                width="10"
                height="10"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 3.69998H0.5V4.19998H1V3.69998ZM1 1V0.5H0.5V1H1ZM3.69998 3.69998L4.15174 3.4857L4.01622 3.19998H3.69998V3.69998ZM8.55994 13.9464L8.99786 14.1877L9.12142 13.9635L9.0117 13.7321L8.55994 13.9464ZM6.73745 17.2539L7.17163 17.502L7.17537 17.4952L6.73745 17.2539ZM25.2998 21.2498V21.7498H25.7998V21.2498H25.2998ZM25.2998 18.5499H25.7998V18.0499H25.2998V18.5499ZM9.32943 18.2124L8.84436 18.0911L8.82943 18.1508V18.2124H9.32943ZM9.36993 18.0504L8.93222 17.8087L8.90068 17.8658L8.88486 17.9291L9.36993 18.0504ZM10.5849 15.8499V15.3499H10.2898L10.1472 15.6082L10.5849 15.8499ZM23.0048 14.4594L22.567 14.2179L22.5664 14.219L23.0048 14.4594ZM27.8378 5.69796L28.2756 5.93947L28.2776 5.93575L27.8378 5.69796ZM27.8105 4.362L27.3807 4.61753V4.61754L27.8105 4.362ZM26.6498 3.69998L26.6509 3.19998H26.6498V3.69998ZM6.68345 3.69998L6.23094 3.91266L6.36598 4.19998H6.68345V3.69998ZM5.41446 1L5.86698 0.787319L5.73194 0.5H5.41446V1ZM1.5 3.69998V1H0.5V3.69998H1.5ZM3.69998 3.19998H1V4.19998H3.69998V3.19998ZM9.0117 13.7321L4.15174 3.4857L3.24822 3.91425L8.10818 14.1607L9.0117 13.7321ZM7.17537 17.4952L8.99786 14.1877L8.12202 13.7051L6.29953 17.0126L7.17537 17.4952ZM6.89996 18.5499C6.89996 18.1631 6.99938 17.8033 7.17158 17.5019L6.30333 17.0058C6.04353 17.4605 5.89996 17.9916 5.89996 18.5499H6.89996ZM9.09993 20.7498C7.89109 20.7498 6.89996 19.7587 6.89996 18.5499H5.89996C5.89996 20.311 7.3388 21.7498 9.09993 21.7498V20.7498ZM25.2998 20.7498H9.09993V21.7498H25.2998V20.7498ZM24.7998 18.5499V21.2498H25.7998V18.5499H24.7998ZM9.66693 19.0499H25.2998V18.0499H9.66693V19.0499ZM8.82943 18.2124C8.82943 18.6775 9.20179 19.0499 9.66693 19.0499V18.0499C9.75407 18.0499 9.82943 18.1252 9.82943 18.2124H8.82943ZM8.88486 17.9291L8.84436 18.0911L9.8145 18.3336L9.855 18.1716L8.88486 17.9291ZM10.1472 15.6082L8.93222 17.8087L9.80764 18.292L11.0226 16.0916L10.1472 15.6082ZM20.6423 15.3499H10.5849V16.3499H20.6423V15.3499ZM22.5664 14.219C22.1937 14.8986 21.4692 15.3499 20.6423 15.3499V16.3499C21.8405 16.3499 22.8979 15.6942 23.4432 14.6998L22.5664 14.219ZM27.4 5.45646L22.567 14.2179L23.4426 14.7009L28.2756 5.93947L27.4 5.45646ZM27.3807 4.61754C27.5343 4.87583 27.5409 5.19583 27.3979 5.46017L28.2776 5.93575C28.5879 5.36188 28.5737 4.66719 28.2403 4.10646L27.3807 4.61754ZM26.6486 4.19998C26.9491 4.20067 27.2272 4.35924 27.3807 4.61753L28.2403 4.10646C27.9069 3.54573 27.3033 3.20148 26.6509 3.19998L26.6486 4.19998ZM6.68345 4.19998H26.6498V3.19998H6.68345V4.19998ZM4.96195 1.21268L6.23094 3.91266L7.13597 3.4873L5.86698 0.787319L4.96195 1.21268ZM1 1.5H5.41446V0.5H1V1.5ZM6.91402 25.3C6.91402 24.0879 7.89491 23.1 9.1005 23.1V22.1C7.33611 22.1 5.91402 23.5422 5.91402 25.3H6.91402ZM9.1005 27.5C7.89491 27.5 6.91402 26.5121 6.91402 25.3H5.91402C5.91402 27.0579 7.33611 28.5 9.1005 28.5V27.5ZM11.3005 25.3C11.3005 26.5089 10.3093 27.5 9.1005 27.5V28.5C10.8616 28.5 12.3005 27.0612 12.3005 25.3H11.3005ZM9.1005 23.1C10.3093 23.1 11.3005 24.0912 11.3005 25.3H12.3005C12.3005 23.5389 10.8616 22.1 9.1005 22.1V23.1ZM22.6004 22.1C20.836 22.1 19.4139 23.5422 19.4139 25.3H20.4139C20.4139 24.0879 21.3948 23.1 22.6004 23.1V22.1ZM25.8004 25.3C25.8004 23.5389 24.3615 22.1 22.6004 22.1V23.1C23.8092 23.1 24.8004 24.0912 24.8004 25.3H25.8004ZM22.6004 28.5C24.3615 28.5 25.8004 27.0612 25.8004 25.3H24.8004C24.8004 26.5089 23.8092 27.5 22.6004 27.5V28.5ZM19.4139 25.3C19.4139 27.0579 20.836 28.5 22.6004 28.5V27.5C21.3948 27.5 20.4139 26.5121 20.4139 25.3H19.4139Z"
                  stroke={"#000000"}
                />
              </svg>
            </>
          }
          <span className={styles.sumary_order_price}>
            {" "}
            {floatToPriceWithoutSpace(totalPedido - todosDescontos)}{" "}
          </span>
        </div>
        <div className={styles.sumary_order_card_header}>
          {isOpen ? (
            <div
              className={styles.sumary_order_option}
              onClick={() => setIsOpen(false)}
            >
              <span className={styles.sumary_order_option}>
                {" "}
                Ocultar resumo da compra{" "}
              </span>
              <BsChevronDown size={12} />
            </div>
          ) : (
            <div onClick={() => setIsOpen(true)}>
              <span className={styles.sumary_order_option}>
                Exibir resumo da compra{" "}
              </span>
              <BsChevronUp size={12} />
            </div>
          )}
        </div>
      </div>
      {isOpen && (
        <div className={styles.resume_cart}>
          <div className={styles.item_resume}>
            <p>Valor dos Produtos</p>
            <p className={styles.price}>
              {floatToPriceWithoutSpace(totalSemDesconto)}
            </p>
          </div>
          <div className={styles.item_resume}>
            <p>Taxa de {type === "withdraw" ? "Retirada" : "Entrega"}</p>
            <p className={styles.price}>{floatToPriceWithoutSpace(freight)}</p>
          </div>
          <div className={styles.item_resume}>
            <p>Desconto</p>
            <p className={styles.price}>
              {floatToPriceWithoutSpace(
                parseFloat(
                  (totalSemDesconto - totalValue + todosDescontos).toFixed(3)
                )
              )}
            </p>
          </div>
          <div className={styles.item_total_resume}>
            <p>Total da Compra</p>
            <p className={styles.price}>
              {floatToPriceWithoutSpace(totalPedido - todosDescontos)}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

type Props = {
  totalWithoutDiscount: number;
  total: number;
  freight: number;
  type: string;
};

const SumaryOrderFinished: FC<Props> = ({
  totalWithoutDiscount,
  total,
  freight,
  type,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const discountContext = useDiscount();

  const discountTotal =
    discountContext.finishData.couponValue +
    discountContext.finishData.paymentDiscountValue;

  return (
    <div className={styles.sumary_order}>
      <div className={styles.sumary_order_card}>
        <div className={styles.sumary_order_card_header}>
          <BsCart2 size={12} />
          <span className={styles.sumary_order_price}>
            {" "}
            {floatToPriceWithoutSpace(total + freight - discountTotal)}{" "}
          </span>
        </div>
        <div className={styles.sumary_order_card_header}>
          {isOpen ? (
            <div
              className={styles.sumary_order_option}
              onClick={() => setIsOpen(false)}
            >
              <span className={styles.sumary_order_option}>
                {" "}
                Ocultar resumo da compra{" "}
              </span>
              <BsChevronUp size={12} />
            </div>
          ) : (
            <div
              className={styles.sumary_order_option}
              onClick={() => setIsOpen(true)}
            >
              <span className={styles.sumary_order_option}>
                Exibir resumo da compra{" "}
              </span>
              <BsChevronDown size={12} />
            </div>
          )}
        </div>
      </div>
      {isOpen && (
        <div className={styles.resume_cart}>
          <div className={styles.item_resume}>
            <p>Valor dos Produtos</p>
            <p className={styles.price}>
              {floatToPriceWithoutSpace(totalWithoutDiscount)}
            </p>
          </div>
          <div className={styles.item_resume}>
            <p>Desconto</p>
            <p className={styles.price}>
              {floatToPriceWithoutSpace(
                parseFloat(
                  (totalWithoutDiscount - total + discountTotal).toFixed(2)
                )
              )}
            </p>
          </div>
          <div className={styles.item_resume}>
            <p>Taxa de {type === "withdraw" ? "Retirada" : "Entrega"}</p>
            <p className={styles.price}>{floatToPriceWithoutSpace(freight)}</p>
          </div>
          <div className={styles.item_total_resume}>
            <p>Total da Compra</p>
            <p className={styles.price}>
              {floatToPriceWithoutSpace(total + freight - discountTotal)}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export { SumaryOrder, SumaryOrderFinished };
